import { Col, Grid, Row } from 'armstrong-react-fix';
import classNames from 'classnames';
import React from "react";
import _ from "underscore";

import "./numericalSelector.scss";

interface INumericalSelectorProps extends React.Props<NumericalSelector> {
  min?: number;
  max: number;
  onChange?: (value: number) => void;
  value?: number;
  disabled?: boolean;
}

export class NumericalSelector extends React.Component<INumericalSelectorProps, { value: number }> {
  private labels = [
    { value: 0, label: "Not at all likely" },
    { value: 1, label: "Not Likely" },
    { value: 2, label: "Not at all likely" },
    { value: 3, label: "Neither " },
    { value: 4, label: "Likely" },
    { value: 5, label: "Extremely likely" },
  ];

  constructor(props: INumericalSelectorProps) {
    super(props);
    this.state = { value: props.value };
  }

  public componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value) {
      this.setState({ value: nextProps.value });
    }
  }

  public onChange(value: number) {
    if (this.props.disabled) {
      return;
    }

    this.setState({ value }, () => {
      if (this.props.onChange) {
        this.props.onChange(value);
      }
    });
  }

  public render() {
    const selection = _.range(this.props.min || 0, this.props.max + 1, 1);
    return (
      <Grid className={classNames("numerical-selector", "m-top-small", { disabled: this.props.disabled })}>
        <Row className="selection-row">
          {selection.map(num =>
            <Col key={num} verticalAlignment="center" horizontalAlignment="center" className={`${this.state.value === num ? "selected" : ""}`} onClick={() => this.onChange(num)}>{num}</Col>,
          )}
        </Row>
        <Row>
          <Col className="t-align-left p-top-xxsmall p-bottom-small"><label>Extremely unlikely</label></Col>
          <Col className="t-align-right p-top-xxsmall p-bottom-small"><label>Extremely Likely</label></Col>
        </Row>
      </Grid>
    );
  }
}
